export default __webpack_public_path__ + "static/dubai-48b620b2cd1dd4c7e6915e1a14a9c31d.svg";